import React from 'react';
import styled from 'styled-components';
import formatUSD from '../../../utils/formatUSD';

const StandardPrice = styled.s`
  color: #8a8a8a;
  margin-right: 0.5em;
`;

interface PricedProduct {
  price: number;
  standard_price?: number | null;
}

interface PriceProps {
  product: PricedProduct;
  showZeroAsFree?: boolean;
}

// Charged price with an optional crossed-out compare-at price. The
// compare-at price is display-only and shows only when it actually exceeds
// what the customer is charged (ENG-2544).
const Price = ({ product, showZeroAsFree = false }: PriceProps) => {
  const chargedPrice =
    showZeroAsFree && product.price === 0 ? 'Free' : formatUSD(product.price);
  const showStandardPrice = (product.standard_price ?? 0) > product.price;

  return (
    <>
      {showStandardPrice && (
        <StandardPrice>{formatUSD(product.standard_price)}</StandardPrice>
      )}
      {chargedPrice}
    </>
  );
};

export default Price;
